import { paymentService } from '../services/payments';

/**
 * Starts Nexi HPP checkout and redirects the browser to the hosted page.
 */
export async function redirectToXpayCheckout(paymentId: string): Promise<void> {
  const checkout = await paymentService.startCheckout(paymentId);
  if (!checkout.hostedPageUrl) {
    throw new Error('Checkout did not return a payment page URL.');
  }
  window.location.href = checkout.hostedPageUrl;
}
